module.exports = __webpack_public_path__ + "01_medium_black.e9964f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_medium_black.png
// module id = mH+4
// module chunks = 0